import React, { memo } from "react";
import { Box, Link as MuiLink, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import SortableTable, { TSortableColumn } from "../../common/SortableTable";

import { selectVariations } from "../../../../features/productAnalyzer/productAnalyzer.selector";
import { IProductVariation } from "../../../../features/productAnalyzer/productAnalyzer.types";
import { capitalizeFirstLetterOfEveryWord } from "../../../../helpers";
import { useAppSelector } from "../../../../store/hooks";
import { FONT_COLORS } from "../../../../constants";

const Variations: React.FC = () => {
  const { variations = [], isLoading } = useAppSelector(selectVariations);

  if (isLoading) return null;

  const tableColumns: TSortableColumn<IProductVariation>[] =
    Object.keys(variations[0] || {})?.map((key) => {
      const isAsin = key.toLowerCase() === "asin";
      const col: TSortableColumn<IProductVariation> = {
        header: capitalizeFirstLetterOfEveryWord(key),
        accessorKey: key,
        align: "left",
        hidden: isAsin,
      };

      if (isAsin) {
        col.html = (data) => (
          <MuiLink
            component={Link}
            to={`https://www.amazon.com/dp/${data.ASIN}`}
            target="_blank"
            display="block"
            sx={{
              textDecoration: "none",
              color: FONT_COLORS.default,
              "&:hover": {
                textDecoration: "underline",
                color: FONT_COLORS.info,
              },
            }}
          >
            {data.ASIN}
          </MuiLink>
        );
      }

      return col;
    }) || [];

  if (!variations.length) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        padding="8px"
      >
        <Typography variant="body1">This listing has no variations.</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <SortableTable
        columns={tableColumns}
        data={variations || []}
        noBorderBottom
        maxHeight="500px"
      />
    </Box>
  );
};

export default memo(Variations);
